import styled from "styled-components";

const Relative = styled.div`
  position: relative;
`;

export default Relative;
